import {
    CONFIRMED_CREATE_COUPON_ACTION,
    CONFIRMED_DELETE_COUPON_ACTION,
    CONFIRMED_EDIT_COUPON_ACTION,
    CONFIRMED_GET_COUPONS,
    CREATE_COUPON_ACTION,    
    CREATE_COUPON_ERROR_ACTION,
    CLEAR_COUPON_ERROR,
    LOADING_COUPONS
} from '../actions/CouponTypes';

const initialState = {
    coupons: [],
    loading: false,
    createCouponError: {}
};

export default function CouponReducer(state = initialState, actions) {
    if (actions.type === CREATE_COUPON_ACTION) { 
        return {
            ...state,
            coupons: [...state.coupons],
        };
    }

    if (actions.type === CONFIRMED_DELETE_COUPON_ACTION) {
        const coupons = state.coupons.filter(coupon => coupon.id !== actions.payload);
        return {
            ...state,
            coupons,
        };
    }

    if (actions.type === CONFIRMED_EDIT_COUPON_ACTION) {
        const coupons = state.coupons.map(coupon => 
            coupon.id === actions.payload.id ? actions.payload : coupon
        );
        return {
            ...state,
            coupons,
        };
    }

    if (actions.type === CONFIRMED_CREATE_COUPON_ACTION) {
        return {
            ...state,
            coupons: [...state.coupons, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_COUPONS) {
        return {
            ...state,
            coupons: actions.payload,
        };
    }

    if (actions.type === LOADING_COUPONS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_COUPON_ERROR_ACTION) {
        return {
            ...state,
            createCouponError: actions.payload,
        };
    }

    if (actions.type === CLEAR_COUPON_ERROR) {
        return {
            ...state,
            createCouponError: {},
        };
    }
    
    return state;
}
